const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function parseEmailList(value?: string | null): string[] {
  if (!value?.trim()) {
    return [];
  }

  return value
    .split(';')
    .map((email) => email.trim())
    .filter(Boolean);
}

export function isValidEmailList(value?: string | null): boolean {
  const emails = parseEmailList(value);
  if (emails.length === 0) {
    return true;
  }

  return emails.every((email) => EMAIL_REGEX.test(email));
}
